export default __webpack_public_path__ + "static/media/RANKEDZONE.4c3ad2ef.png";